import React from 'react';
import {Redirect, Route, Switch} from 'react-router';

import {DASHBOARD_PAGE, FAQ_PAGE, INDEX_PAGE, PROFILE_PAGE, WORKERS_PAGE} from './paths';
import {get, set} from '../services/store';
import DashboardPage from '../components/pages/DashboardPage';
import Navigation from '../components/navigation/Navigation';
import WorkersPage from '../components/pages/WorkersPage';
import ProfilePage from '../components/pages/ProfilePage';
import IndexPage from '../components/pages/IndexPage';
import FaqPage from '../components/pages/FaqPage';
import {parse} from 'qs';


const ifLoggedIn = (component) => get('token') ? component : <Redirect to={INDEX_PAGE}/>;

const ifLoggedInDash = (location, component) => {
    set('dashboardToken', parse(location.search, {ignoreQueryPrefix: true}).dashboardToken);
    if (get('token') || get('dashboardToken')) {
        return component;
    }
    return <Redirect to={INDEX_PAGE}/>;
};

const routes = () => (
    <Navigation>
        <Switch>
            <Route exact path={INDEX_PAGE} component={IndexPage}/>
            <Route exact path={DASHBOARD_PAGE} render={({location}) => ifLoggedInDash(location, <DashboardPage/>)}/>
            <Route exact path={WORKERS_PAGE} render={({location}) => ifLoggedInDash(location, <WorkersPage/>)}/>
            <Route exact path={PROFILE_PAGE} render={() => ifLoggedIn(<ProfilePage/>)}/>
            <Route exact path={FAQ_PAGE} component={FaqPage}/>
            <Redirect to={INDEX_PAGE}/>
        </Switch>
    </Navigation>
);

export default routes;



// WEBPACK FOOTER //
// /src/configuration/routes.jsx